import axios from "@/utils/axios";

export default async function (sessions: any) {
  const response = await axios.patch(`/user/invalidate-sessions`, { sessions });

  const data = response.data;

  return data;
}
